<template>
  <div class="rounded-md" :class="{ 'p-4 border-2 border-gray-6': outlined }">
    <ValidationObserver
      ref="observer"
      tag="div"
      class="flex flex-col flex-grow justify-center"
      :class="{ 'space-y-2': outlined, 'space-y-4': !outlined }"
    >
      <WidgetWrapper
        v-for="field in fieldElements"
        :key="field.id"
        :field="field"
        is-static-error
      />
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import { SurveyGroupingElement } from '@/models/survey-elements/grouping-element';
import WidgetWrapper from '@/components/WidgetWrapper.vue';
import { SurveyElementsUnion } from '@/models/survey-elements-union';

@Component({
  name: 'grouping-element',
  components: {
    WidgetWrapper,
    ValidationObserver,
    FieldValidationError: () => import('@/components/FieldValidationError.vue'),
  },
})
export default class GroupingElementWidget extends Vue {
  $refs!: Vue['$refs'] & {
    observer: InstanceType<typeof ValidationObserver>;
  };
  @Prop({ type: Object }) field?: SurveyGroupingElement;
  @Prop({ type: Boolean, default: true }) outlined!: boolean;

  private get fieldElements() {
    return this.field?.elements.sort((a, b) => a.order - b.order);
  }
}
</script>
